// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Montserrat:400,800);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    box-sizing: border-box;
}

.bodyVt {
    background: #f6f5f7;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    font-family: 'Montserrat', sans-serif;
    height: 100vh;
}

.h1Vt {
    font-weight: bold;
    margin: 0;
}

.h2Vt {
    text-align: center;
}

.pVt {
    font-size: 14px;
    font-weight: 100;
    line-height: 20px;
    letter-spacing: 0.5px;
    margin: 20px 0 30px;
}

span {
    font-size: 12px;
}

.aVt {
    color: #333;
    font-size: 14px;
    text-decoration: none;
    margin: 15px 0;
}

.buttonVt {
    border-radius: 20px;
    border: 1px solid #61CE70;
    background-color: #61CE70;
    color: #FFFFFF;
    font-size: 12px;
    font-weight: bold;
    padding: 12px 45px;
    letter-spacing: 1px;
    text-transform: uppercase;
    transition: transform 80ms ease-in;
    color: rgba(255, 246, 246, 0.788);
}

.buttonVt:active {
    transform: scale(0.95);
}

.buttonVt:focus {
    outline: none;
}

.buttonVt.ghost {
    background-color: transparent;
    border-color: #FFFFFF;
}

.forms {
    background-color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 0 50px;
    height: 100%;
    text-align: center;
}

.inputs {
    background-color: #eee;
    border: none;
    padding: 12px 15px;
    margin: 8px 0;
    width: 100%;
}

.containerVt {
    background-color: #fff;
    border-radius: 10px;
    box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25),
        0 10px 10px rgba(0, 0, 0, 0.22);
    position: relative;
    overflow: hidden;
    width: 768px;
    max-width: 100%;
    min-height: 480px;
}

.form-container {
    position: absolute;
    top: 0;
    height: 100%;
    transition: all 0.6s ease-in-out;
}

.sign-in-container {
    left: 0;
    width: 50%;
    z-index: 2;
}

.container.right-panel-active .sign-in-container {
    transform: translateX(100%);
}

.sign-up-container {
    left: 0;
    width: 50%;
    opacity: 0;
    z-index: 1;
}

.container.right-panel-active .sign-up-container {
    transform: translateX(100%);
    opacity: 1;
    z-index: 5;
    animation: show 0.6s;
}

@keyframes show {

    0%,
    49.99% {
        opacity: 0;
        z-index: 1;
    }

    50%,
    100% {
        opacity: 1;
        z-index: 5;
    }
}

.overlay-container {
    position: absolute;
    top: 0;
    left: 50%;
    width: 50%;
    height: 100%;
    overflow: hidden;
    transition: transform 0.6s ease-in-out;
    z-index: 100;
}

.container.right-panel-active .overlay-container {
    transform: translateX(-100%);
}

.overlay {
    background: #61CE70;
    background: linear-gradient(to right, #9acaa0, #61CE70);
    background-repeat: no-repeat;
    background-size: cover;
    background-position: 0 0;
    color: #FFFFFF;
    position: relative;
    left: -100%;
    height: 100%;
    width: 200%;
    transform: translateX(0);
    transition: transform 0.6s ease-in-out;
}

.container.right-panel-active .overlay {
    transform: translateX(50%);
}

.overlay-panel {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 0 40px;
    text-align: center;
    top: 0;
    height: 100%;
    width: 50%;
    transform: translateX(0);
    transition: transform 0.6s ease-in-out;
}

.overlay-left {
    transform: translateX(-20%);
}

.container.right-panel-active .overlay-left {
    transform: translateX(0);
}

.overlay-right {
    right: 0;
    transform: translateX(0);
}

.container.right-panel-active .overlay-right {
    transform: translateX(20%);
}

.social-container {
    margin: 20px 0;
}

.social-container a {
    border: 1px solid #DDDDDD;
    border-radius: 50%;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    margin: 0 5px;
    height: 40px;
    width: 40px;
}

@media screen and (max-width: 532px) {
    p {
        font-size: 8px;
    }

    span {
        font-size: 6px;
    }

    a {
        color: #333;
        font-size: 8px;
    }

    button {

        font-size: 6px;

    }

    /*  input {
       
    } */
    .buttonVt {
        font-size: 8px;
        padding: 5px 10px;
        font-weight: 500;
    }

    .inputs {
        background-color: #eee;
        border: none;
        padding: 6px 6px;
        margin: 8px 0;
        width: 150px;
        height: 30px;
        width: 200px;
    }

}`, "",{"version":3,"sources":["webpack://./src/screens/Login/style.css"],"names":[],"mappings":"AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,qCAAqC;IACrC,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,SAAS;AACb;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,kCAAkC;IAClC,iCAAiC;AACrC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,6BAA6B;IAC7B,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,eAAe;IACf,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB;uCACmC;IACnC,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,YAAY;IACZ,gCAAgC;AACpC;;AAEA;IACI,OAAO;IACP,UAAU;IACV,UAAU;AACd;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,OAAO;IACP,UAAU;IACV,UAAU;IACV,UAAU;AACd;;AAEA;IACI,2BAA2B;IAC3B,UAAU;IACV,UAAU;IACV,oBAAoB;AACxB;;AAEA;;IAEI;;QAEI,UAAU;QACV,UAAU;IACd;;IAEA;;QAEI,UAAU;QACV,UAAU;IACd;AACJ;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,sCAAsC;IACtC,YAAY;AAChB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;IAEnB,uDAAuD;IACvD,4BAA4B;IAC5B,sBAAsB;IACtB,wBAAwB;IACxB,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,wBAAwB;IACxB,sCAAsC;AAC1C;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,eAAe;IACf,kBAAkB;IAClB,MAAM;IACN,YAAY;IACZ,UAAU;IACV,wBAAwB;IACxB,sCAAsC;AAC1C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,QAAQ;IACR,wBAAwB;AAC5B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,YAAY;IACZ,WAAW;AACf;;AAEA;IACI;QACI,cAAc;IAClB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,WAAW;QACX,cAAc;IAClB;;IAEA;;QAEI,cAAc;;IAElB;;IAEA;;OAEG;IACH;QACI,cAAc;QACd,iBAAiB;QACjB,gBAAgB;IACpB;;IAEA;QACI,sBAAsB;QACtB,YAAY;QACZ,gBAAgB;QAChB,aAAa;QACb,YAAY;QACZ,YAAY;QACZ,YAAY;IAChB;;AAEJ","sourcesContent":["@import url('https://fonts.googleapis.com/css?family=Montserrat:400,800');\n\n* {\n    box-sizing: border-box;\n}\n\n.bodyVt {\n    background: #f6f5f7;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    font-family: 'Montserrat', sans-serif;\n    height: 100vh;\n}\n\n.h1Vt {\n    font-weight: bold;\n    margin: 0;\n}\n\n.h2Vt {\n    text-align: center;\n}\n\n.pVt {\n    font-size: 14px;\n    font-weight: 100;\n    line-height: 20px;\n    letter-spacing: 0.5px;\n    margin: 20px 0 30px;\n}\n\nspan {\n    font-size: 12px;\n}\n\n.aVt {\n    color: #333;\n    font-size: 14px;\n    text-decoration: none;\n    margin: 15px 0;\n}\n\n.buttonVt {\n    border-radius: 20px;\n    border: 1px solid #61CE70;\n    background-color: #61CE70;\n    color: #FFFFFF;\n    font-size: 12px;\n    font-weight: bold;\n    padding: 12px 45px;\n    letter-spacing: 1px;\n    text-transform: uppercase;\n    transition: transform 80ms ease-in;\n    color: rgba(255, 246, 246, 0.788);\n}\n\n.buttonVt:active {\n    transform: scale(0.95);\n}\n\n.buttonVt:focus {\n    outline: none;\n}\n\n.buttonVt.ghost {\n    background-color: transparent;\n    border-color: #FFFFFF;\n}\n\n.forms {\n    background-color: #FFFFFF;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    padding: 0 50px;\n    height: 100%;\n    text-align: center;\n}\n\n.inputs {\n    background-color: #eee;\n    border: none;\n    padding: 12px 15px;\n    margin: 8px 0;\n    width: 100%;\n}\n\n.containerVt {\n    background-color: #fff;\n    border-radius: 10px;\n    box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25),\n        0 10px 10px rgba(0, 0, 0, 0.22);\n    position: relative;\n    overflow: hidden;\n    width: 768px;\n    max-width: 100%;\n    min-height: 480px;\n}\n\n.form-container {\n    position: absolute;\n    top: 0;\n    height: 100%;\n    transition: all 0.6s ease-in-out;\n}\n\n.sign-in-container {\n    left: 0;\n    width: 50%;\n    z-index: 2;\n}\n\n.container.right-panel-active .sign-in-container {\n    transform: translateX(100%);\n}\n\n.sign-up-container {\n    left: 0;\n    width: 50%;\n    opacity: 0;\n    z-index: 1;\n}\n\n.container.right-panel-active .sign-up-container {\n    transform: translateX(100%);\n    opacity: 1;\n    z-index: 5;\n    animation: show 0.6s;\n}\n\n@keyframes show {\n\n    0%,\n    49.99% {\n        opacity: 0;\n        z-index: 1;\n    }\n\n    50%,\n    100% {\n        opacity: 1;\n        z-index: 5;\n    }\n}\n\n.overlay-container {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    width: 50%;\n    height: 100%;\n    overflow: hidden;\n    transition: transform 0.6s ease-in-out;\n    z-index: 100;\n}\n\n.container.right-panel-active .overlay-container {\n    transform: translateX(-100%);\n}\n\n.overlay {\n    background: #61CE70;\n    background: -webkit-linear-gradient(to right, #9acaa0, #61CE70);\n    background: linear-gradient(to right, #9acaa0, #61CE70);\n    background-repeat: no-repeat;\n    background-size: cover;\n    background-position: 0 0;\n    color: #FFFFFF;\n    position: relative;\n    left: -100%;\n    height: 100%;\n    width: 200%;\n    transform: translateX(0);\n    transition: transform 0.6s ease-in-out;\n}\n\n.container.right-panel-active .overlay {\n    transform: translateX(50%);\n}\n\n.overlay-panel {\n    position: absolute;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    padding: 0 40px;\n    text-align: center;\n    top: 0;\n    height: 100%;\n    width: 50%;\n    transform: translateX(0);\n    transition: transform 0.6s ease-in-out;\n}\n\n.overlay-left {\n    transform: translateX(-20%);\n}\n\n.container.right-panel-active .overlay-left {\n    transform: translateX(0);\n}\n\n.overlay-right {\n    right: 0;\n    transform: translateX(0);\n}\n\n.container.right-panel-active .overlay-right {\n    transform: translateX(20%);\n}\n\n.social-container {\n    margin: 20px 0;\n}\n\n.social-container a {\n    border: 1px solid #DDDDDD;\n    border-radius: 50%;\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    margin: 0 5px;\n    height: 40px;\n    width: 40px;\n}\n\n@media screen and (max-width: 532px) {\n    p {\n        font-size: 8px;\n    }\n\n    span {\n        font-size: 6px;\n    }\n\n    a {\n        color: #333;\n        font-size: 8px;\n    }\n\n    button {\n\n        font-size: 6px;\n\n    }\n\n    /*  input {\n       \n    } */\n    .buttonVt {\n        font-size: 8px;\n        padding: 5px 10px;\n        font-weight: 500;\n    }\n\n    .inputs {\n        background-color: #eee;\n        border: none;\n        padding: 6px 6px;\n        margin: 8px 0;\n        width: 150px;\n        height: 30px;\n        width: 200px;\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
